import config from "@/config"
import http from "@/utils/request"

export default {
	token: {
		url: `${config.MAIN_URL}/auth/v2/server/login`,
		name: '登录获取TOKEN',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	getGaaerTokenByKey: {
		url: `${config.MAIN_URL}/api/v1/admin/dkmh/getGaaerTokenByKey`,
		name: '登录获取TOKEN',
		post: async function (data) {
			return await http.post(this.url + data);
		},
	},
	getTokenByUid: {
		url: `${config.MAIN_URL}/taian/auth/getTokenByUid`,
		name: '根据UUID获取token',
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	menu: {
		url: `${config.MAIN_URL}/permission/menu/management/getMenuTree`,
		name: '获取菜单',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getVerifycode: {
		url: `${config.MAIN_URL}/auth/v2/server/getVerifycode`,
		name: '获取验证码',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	outLogin: {
		url: `${config.MAIN_URL}/admin/api/admin/logout`,
		name: '退出登录',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	smsCode: {
		url: `${config.MAIN_URL}/auth/v2/check/smsCode`,
		name: '校验验证码',
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	weatherNow: {
		url: `${config.HNYJ_URL}/api/v1/admin/weatherMeteo/now`,
		name: '实时天气',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	weatherCitySearch: {
		url: `${config.HNYJ_URL}/api/v1/admin/weatherMeteo/city/search`,
		name: '城市搜索',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},

}
